export default "__VITE_ASSET__d96d0ef1__"